import { Window } from '../../00_IMMEDIATE/Window';
import LevelEconomyTracker from '../GameTracking/LevelEconomyTracker';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import { LevelType } from '../GameState/Managers/GameEnums';

/**
 * Window for giving up on a level
 */
class Window_GiveUp extends Window {
    /**
     * constructor
     * @param {Object} parent
     * @param {Function} onGiveUp
     */
    constructor(parent, onGiveUp) {
        super(parent);
        this.state = game.state.getCurrentState();
        this._initLayout();
        this._initButtons(onGiveUp);
    }

    /**
     * init window layout
     */
    _initLayout() {
        // gingy / mascot image
        const gingyImage = G.makeImage(0, -380, 'sad_gingy_heart_small', 0.5, this);
        // gingyImage.scale.setTo(1.33, 1.33);
        // gingyImage.rotation = -30 * (Math.PI / 180);

        // set background
        this.addBackground('popup_background_2');

        const yOffset = G.OMTsettings.global.jungleMatch ? -210 : -272;

        // level info text
        this._levelTxt = new G.Text(0, yOffset,
            this.state.mode === LevelType.NORMAL ? `${OMT.language.getText('Level')} ${G.lvl.lvlIndex + 1}` : OMT.language.getText('Daily Challenge'),
            G.OMTsettings.global.window.mediumTitle.textStyle, 0.5, 440);

        this.add(this._levelTxt);

        // lost progress warning
        this._loseProgressTxt = new G.Text(0, -70, OMT.language.getText('Your level progress will be lost!'), {
            style: 'font-purple',
            fontSize: '45px',
        }, 0.5, 500, 140, true, 'center');
        this.add(this._loseProgressTxt);

        // player id text field
        // this._playerIdText = new G.Text(0, 295,
        //   // eslint-disable-next-line prefer-template
        //   'Player ID: ' + (
        //     typeof OMT.envData.settings.user.userId === 'number'
        //       ? OMT.envData.settings.user.userId.toString() : OMT.envData.settings.user.userId
        //   ),
        //   {
        //     style: 'font-purple',
        //     fontSize: '20px',
        //   }, 0.5, 440);
        // this.add(this._playerIdText);

        // lives status text / image
        if (G.LIVES && this.state._removedLifeAtStart) {
            this._brokenHeart = G.makeImage(-120, 215, 'broken_heart', 0.5, this);
            this.minusOneTxt = new G.Text(-125, 215, '-1', {
                style: 'font-white',
                fontSize: '35px',
            }, 0.5, 50);
            this.add(this.minusOneTxt);
        }
    }

    /**
     * init buttons
     * @param {Function} onGiveUp
     */
    _initButtons(onGiveUp) {
        // close button
        this.addCloseButton();

        // give up button
        const giveUpClick = () => {
            G.sb('onLevelFailed').dispatch();
            if (this.state.mode === LevelType.CHALLENGE) {
                G.sb('onDailyChallengeFinished').dispatch();
            }
            if (G.MYSTERYGIFT) {
                G.saveState.mysteryGift_finishStreak();
            }
            G.winsInRow = 0;
            G.saveState.resetCWinCount();
            if (this.state.mode !== LevelType.CHALLENGE) {
                LevelEconomyTracker.getInstance().finishLevel(0);
            }

            sdkHandler.trigger('levelFinish', {
                level: G.lvl.lvlIndex + 1,
                score: G.lvl.points,
                state: 'lose'
            }, this);

            sdkHandler.trigger('playButtonPressed', {
                callback: () => {
                    if (onGiveUp) onGiveUp();
                }
            }, this);

            // this.state.endPointCheckForAds(() => {
            //   if (onGiveUp) onGiveUp();
            // });
        };
        this._giveUpBtn = new OMT_UI_SquareButton(0, 215, {
            button: {
                tint: BUTTONCOLOURS.red,
                dimensions: {
                    width: 166,
                    height: 86,
                },
                extraDetail: false,
            },
            text: {
                string: OMT.language.getText('Give up'),
                textStyle: {
                    style: 'font-white',
                    fontSize: 50,
                },
                dimensionMods: {
                    height: 0.9,
                    width: 0.9,
                },
            },
            options: {
                clickFunction: {
                    onClick: giveUpClick.bind(this),
                },
            },
        });

        sdkHandler.trigger('beforePlayButtonDisplay', {
            callback: () => {
                this.registerButtons(this._giveUpBtn);
            }
        }, this);

        // continue button
        const onClick = () => {
            this.closeWindow();
        };
        this._continueBtn = new OMT_UI_SquareButton(0, 100, {
            button: {
                tint: BUTTONCOLOURS.green,
                dimensions: {
                    width: 309,
                    height: 100,
                },
            },
            text: {
                string: OMT.language.getText('Keep Playing'),
                textStyle: {
                    style: 'font-white',
                    fontSize: 50,
                },
            },
            options: {
                clickFunction: {
                    onClick: onClick.bind(this),
                },
                pulse: 1.1,
            },
        });
        this.registerButtons(this._continueBtn);
    }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.giveUp = Window_GiveUp;